<template>
  <el-dialog
    title="回放列表"
    :visible.sync="dialogVisible"
    width="1000px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose">
      <el-table :data="list" border>
        <el-table-column align="center" label="id" prop="id"></el-table-column>
        <el-table-column align="center" label="回放标题" prop="title"></el-table-column>
        <el-table-column align="center" label="回放url" prop="videoUrl"></el-table-column>
        <el-table-column align="center" label="发布状态" prop="publishStatus">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.publishStatus === 1">未发布</el-tag>
            <el-tag v-if="scope.row.publishStatus === 2">已发布</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="回放id" prop="replyId"></el-table-column>
        <el-table-column align="center" label="回放的资源id" prop="recordId"></el-table-column>
        <el-table-column align="center" label="离线包地址" prop="offlinePackageUrl"></el-table-column>
        <el-table-column align="center" label="操作" prop="">
          <template slot-scope="scope">
            <a href="javascript:;" @click="handlePublishReplay(scope.row)">发布回放</a>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
      </span>
  </el-dialog>
</template>

<script>
import { listLesperiodReply, handlePublishReplay } from '@/api/class/lesperiod'
export default {
  name: 'PlaybackList',
  data () {
    return {
      dialogVisible: false,
      lesperiodId: null,
      list: []
    }
  },
  methods: {
    init(lesperiodId) {
      this.lesperiodId = lesperiodId
      this.listLesperiodReply()
      this.dialogVisible = true
    },
    async listLesperiodReply() {
      const res = await listLesperiodReply({lesperiodId: this.lesperiodId})
      this.list = res.data
    },
    async handlePublishReplay(row) {
      const res = await handlePublishReplay({id: row.id})
      this.$message.success('操作成功!')
      this.listLesperiodReply()
    },
    handleClose() {
      this.dialogVisible = false
      this.lesperiodId = null
      this.list = []
    }
  }
}
</script>

<style lang="scss" scoped>
.playbackList {

}
</style>
